import {FC} from 'react';
import {Box, FormControl, FormControlLabel, RadioGroup, Typography} from '@mui/material';
// import {ReactComponent as BankIcon} from '@/assets/icons/bank.svg';
import {PRIMARY, SUBTITLE1} from '@/utils/constants';
import {ReactComponent as CardIcon} from '@/assets/icons/card.svg';
import {paymentOptionsStyles} from './PaymentOptions.styles';
import Radio from '@/shared/components/Radio';
import {PAYMENT_METHOD} from '@/utils/enums';

interface PaymentOptionsProps {
  value: string;
  onChange: (value: PAYMENT_METHOD) => void;
}

const PaymentOptions: FC<PaymentOptionsProps> = ({value, onChange}) => {
  const options = [
    {
      id: PAYMENT_METHOD.CREDIT_CARD,
      label: 'Pay with Credit Card',
      icon: <CardIcon />,
    },
    // {
    //   id: PAYMENT_METHOD.BANK_TRANSFER,
    //   label: 'Bank Transfer',
    //   icon: <BankIcon />,
    // },
  ];

  return (
    <Box>
      <FormControl component="fieldset" fullWidth>
        <RadioGroup value={value} onChange={(e) => onChange(e.target.value as PAYMENT_METHOD)}>
          <Box sx={paymentOptionsStyles.content}>
            {options.map((option) => {
              const isActive = value === option.id;

              return (
                <Box
                  key={option.id}
                  sx={{
                    ...paymentOptionsStyles.radio,
                    ...(isActive && paymentOptionsStyles.activeRadio),
                    mb: 2,
                  }}
                >
                  <FormControlLabel
                    value={option.id}
                    control={<Radio color={PRIMARY} />}
                    label={
                      <Box sx={paymentOptionsStyles.radioLabel}>
                        {option.icon}
                        <Typography variant={SUBTITLE1} sx={paymentOptionsStyles.radioTitle}>
                          {option.label}
                        </Typography>
                      </Box>
                    }
                  />
                </Box>
              );
            })}
          </Box>
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default PaymentOptions;
